module.exports = __webpack_public_path__ + "static/media/retweet.407abea2.svg";